// src/utils/signOutAndClearCache.js
import { auth, db } from "../firebase";
import { terminate, clearIndexedDbPersistence } from "firebase/firestore";

/**
 * Sign out and wipe the on-disk Firestore cache.
 *
 * Firestore now caches documents in IndexedDB so a reload paints from disk
 * instead of re-downloading the account's whole diary. That cache outlives the
 * session, so on a shared salon device the next person to sign in would be
 * sitting on top of the previous account's data — clear it as part of logging
 * out.
 *
 * `terminate` leaves the Firestore instance unusable, so the caller must do a
 * full page load rather than a client-side navigation; this returns the target
 * URL to send the browser to.
 *
 * Clearing fails while another tab still holds the database open. That's not
 * worth blocking a logout over — the sign-out itself has already happened.
 */
export default async function signOutAndClearCache(redirectTo = "/login") {
  try {
    await auth.signOut();
  } finally {
    try {
      await terminate(db);
      await clearIndexedDbPersistence(db);
    } catch (err) {
      console.warn(
        "[signOut] Could not clear the local Firestore cache:",
        err?.message || err,
      );
    }
  }

  window.location.assign(redirectTo);
}
